 const HaifaCoords = [
  { lat:32.76173252775458,  lng:35.05543509828527},
  {lat: 32.77734091195183,  lng: 35.03904143678625},
  {lat: 32.790257472115144, lng :35.026424325580194},
  {lat: 32.801511015863426, lng :35.01415096948796},
  {lat: 32.8126206799118, lng :35.004967085820965},
  {lat: 32.820555303982964, lng :34.99810063074284},
  {lat: 32.82627806122271, lng :34.99104421948517},
  {lat: 32.831279242510206, lng :34.98913764953613},
  {lat: 32.83459674730089, lng :34.9845027923584},
  {lat: 32.83536573638877, lng :34.97872751568878},
  {lat: 32.831519106186555, lng :34.9726089162653},
  {lat: 32.831207121464274, lng :34.9680233001709},
  {lat: 32.82788334370175, lng :34.96110760400944},
  {lat: 32.82067364675476, lng :34.957110862798686},
  {lat: 32.818004810392395, lng :34.955909233160014},
  {lat: 32.81252262477655, lng :34.95642421729087},
  {lat: 32.80509545480254, lng :34.95669364929199},
  {lat: 32.79963118462892, lng :34.957110862798686},
  {lat: 32.79320760121929, lng :34.95676754004478},
  {lat: 32.7856149065647, lng :34.9559211730957},
  {lat: 32.78307990068783, lng :34.95656646114463},
  {lat: 32.76708390091623, lng :34.955915981119176},
  {lat: 32.76369170013534, lng :34.956173473184606},
  {lat: 32.76001065519267, lng :34.95454269010355},
  {lat: 32.749471920436335, lng :34.95282607633402},
  {lat: 32.74860566759879, lng :34.96449904996683},
  {lat: 32.749255358016704, lng :34.967159801309606},
  {lat: 32.74795597244248, lng :34.974455409830114},
  {lat: 32.758340203380335, lng :34.982389188330956},
  {lat: 32.760134367323225, lng :34.99358453299379},
  {lat: 32.763503498479864, lng :34.99931095135793},
  {lat: 32.76441857676915, lng :35.005209031099014},
  {lat: 32.7602091066394, lng :35.008017206054944},
  {lat: 32.759464110666116, lng :35.01425860854994},
  {lat: 32.753885485244425, lng :35.02746541420862},
  {lat: 32.74719790845441, lng :35.03192304982605},
  {lat: 32.745058581697705, lng :35.03439538660803},
  {lat: 32.74494057610592, lng :35.03721104614391},
  {lat: 32.750738276643744, lng :35.039885770578856},
  {lat: 32.75570236320011, lng :35.03818612338171},
  {lat: 32.76008874469832, lng :35.03408321690714},
  {lat: 32.76424175281716, lng :35.03514711831355},
  {lat: 32.759122801207916, lng :35.05203779954435},
  {lat: 32.76086124190655, lng :35.045270919799805},
    /*{ lat: 32.76481371320269, lng: lng :35.053538224742795 },
    { lat: 32.76481371320269, lng: 35.053538224742795 },
    { lat: 32.79223596895451, lng: 35.03225221400061 },
    { lat: 32.81500584962064, lng: 35.011853646062825 },
    { lat: 32.83581988425926, lng: lng :34.98521699671545 },
    { lat: 32.82760077631477, lng: 34.95929612879553 },
    { lat: 32.81707269595755, lng: 34.95534791712561 },
    { lat: 32.758193042017524, lng: 34.95225801234045 },
    { lat: 32.76129430977934, lng: 34.994544982910156 },*/
  ];

  


  export default HaifaCoords ;



   
   